import { useCallback, useEffect, useMemo, useState } from 'react';
import { PurchaseItemResponse } from '@Types/api/form';
import { MInput, MSkeleton } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { useGetPurchaseItemsMutation } from '@Features/MaterialRequest/requests/PurchaseRequest/store/api/purchaseRequestApiSlice';

import { findPurchaseMaterialItemBySearchValue } from '@Features/MaterialRequest/requests/utils/finder';

import MaterialTabItem from './MaterialTabItem';

import styles from '../view-tab.module.css';

const MaterialsTab: React.FC = () => {
  const requestId = useAppSelector(getModalRecordKey);
  const [getPurchaseItems, { isSuccess }] = useGetPurchaseItemsMutation();
  const [listItems, setListItems] = useState<Array<PurchaseItemResponse>>();
  const [searchedMatItems, setSearchedMatItems] =
    useState<Array<PurchaseItemResponse>>();

  const handleSearchMaterialItems = useCallback(
    (value: string) => {
      if (listItems?.length) {
        const result = findPurchaseMaterialItemBySearchValue(listItems, value);
        setSearchedMatItems(result);
      }
    },
    [listItems]
  );

  const listMatItems = useMemo(() => {
    if (!searchedMatItems?.length) {
      return listItems;
    }
    return searchedMatItems;
  }, [searchedMatItems, listItems]);

  useEffect(() => {
    if (requestId) {
      getPurchaseItems(Number(requestId))
        .unwrap()
        .then((response) => {
          setListItems(response);
        });
    }
  }, [requestId]);

  return (
    <div className={styles.viewTabMaterials}>
      <MInput
        className={styles.search}
        searchInput
        placeholder="Search..."
        onChange={(event) => handleSearchMaterialItems(event.target.value)}
        disabled={!isSuccess}
      />
      {isSuccess ? (
        <div className={styles.container}>
          {listMatItems &&
            listMatItems.map((item) => (
              <MaterialTabItem
                index={item.reqItemId}
                materialCode={item?.matCode || ''}
                materialDesc={item.matDesc}
                qty={item.reqQty}
                unit={item.unitName}
                key={item.reqItemId}
              />
            ))}
        </div>
      ) : (
        <div className={styles.container}>
          <MSkeleton repeat={2} className="skeleton-item" />
        </div>
      )}
    </div>
  );
};

export default MaterialsTab;
